import { PieChart, ClipboardList, BookOpen } from "lucide-react";
import React from "react";

const HowWeHelp = () => {
  const categories = [
    {
      icon: <PieChart />,
      title: "Mutual Fund Investing",
      description: "SIPs and long-term planning based on your income & goals",
    },
    {
      icon: <ClipboardList />,
      title: "Portfolio Review",
      description:
        "We review your existing investments and highlight gaps & risks",
    },
    {
      icon: <BookOpen />,
      title: "Market Education",
      description: "Understand markets calmly no hype, no shortcuts",
    },
  ];

  return (
    <div className="border border-black-dark-200 w-full rounded-3xl py-24">
      <section className="max-w-screen-xl mx-auto px-6 md:px-10">
        {/* Heading */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-6xl xl:text-7xl font-bold text-white">
            How <span className="text-primary1">TradeTact </span>Helps You
          </h2>
          <p className="mt-6 text-gray-300 text-base sm:text-lg">
            Clear guidance. No hype. No pressure.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {/* Card 1 */}
          <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6">
            <PieChart className="h-8 w-8 text-green-500 mb-4" />
            <h3 className="text-lg font-medium text-white mb-2">
              Mutual Fund Investing
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              SIPs and long-term planning based on your income & goals.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6">
            <ClipboardList className="h-8 w-8 text-green-500 mb-4" />
            <h3 className="text-lg font-medium text-white mb-2">
              Portfolio Review
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              We review your existing investments and highlight gaps & risks.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6">
            <BookOpen className="h-8 w-8 text-green-500 mb-4" />
            <h3 className="text-lg font-medium text-white mb-2">
              Market Education
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Understand markets calmly no hype, no shortcuts.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HowWeHelp;
